/** @jsxRuntime classic */
/** @jsx jsx */
import {
  AuthRestrict,
  LibraryBanner,
  LibraryNavigation,
  mq,
  SharedLayout,
  UpgradeNudge,
  useSubscriptionInfo,
} from "@app/components";
import { useSharedQuery } from "@app/graphql";
import { jsx } from "@emotion/react";
import { NextPage } from "next";

const Library: NextPage = () => {
  const query = useSharedQuery();
  const { isTrialEnded, isSubscriptionPastDue, isAdmin } = useSubscriptionInfo();

  return (
    <div>
      <LibraryStyleArtifact />
      <SharedLayout title="" query={query} forbidWhen={AuthRestrict.NEVER}>
        <div>
          <LibraryBanner></LibraryBanner>
          <UpgradeNudge />

          <div css={{ filter: (isTrialEnded || isSubscriptionPastDue) && !isAdmin ? "grayscale(1)" : "none" }}>
            <LibraryNavigation></LibraryNavigation>
          </div>
        </div>
      </SharedLayout>
    </div>
  );
};

export const LibraryStyleArtifact = () => (
  <svg
    css={{ position: "absolute", zIndex: 1, top: 60, right: 0, width: 230, [mq.sm]: { width: 370 } }}
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 423.78 237.48"
  >
    <path
      css={{ fill: "#cf5078" }}
      d="M419.22,212.75a4.25,4.25,0,0,1,2,.2C420.54,212.85,419.81,213.49,419.22,212.75Z"
    />
    <path
      css={{ fill: "#08a8f7" }}
      d="M202.43,211.58a9.08,9.08,0,0,1-1.42-.47h0l-51.78-21.9a9.29,9.29,0,0,1-4.93-12.16l21.9-51.77a9.28,9.28,0,0,1,12.16-4.93l51.78,21.9a9.3,9.3,0,0,1,4.93,12.16l-21.9,51.77A9.3,9.3,0,0,1,202.43,211.58Zm2.08-8.76a.29.29,0,0,0,.37-.15l21.9-51.77a.28.28,0,0,0-.15-.36l-51.77-21.9a.27.27,0,0,0-.37.14l-21.9,51.78a.28.28,0,0,0,0,.21.23.23,0,0,0,.15.15Z"
    />
    <path
      css={{ fill: "#08a8f7" }}
      d="M128.23,31.9a7.65,7.65,0,0,0,3.16,10.37l37.69,20.07a7.68,7.68,0,0,0,10.38-3.17l20.06-37.68a7.67,7.67,0,0,0-3.16-10.38L176.08.31H145Z"
    />
    <rect
      css={{ fill: "#08a8f7" }}
      x="210.34"
      y="41.79"
      width="29.04"
      height="29.04"
      rx="5.61"
      transform="translate(-5.01 86.21) rotate(-21.47)"
    />
    <path css={{ fill: "#00b4a3" }} d="M99.23,47.56a7.5,7.5,0,1,0,8.55-12.32L57.39.31H31.05Z" />
    <path
      css={{ fill: "#00b4a3" }}
      d="M82.07,127a7.5,7.5,0,0,1-2.75-14.48L160.5,80.61a7.5,7.5,0,1,1,5.49,14L84.81,126.5A7.56,7.56,0,0,1,82.07,127Z"
    />
    <circle css={{ fill: "#00b4a3" }} cx="256.66" cy="141.56" r="61" />
    <path
      css={{ fill: "#08a8f7" }}
      d="M423.66,29.67,344,100.8,254.26.31H234.68a12.16,12.16,0,0,0,1.72,2.53l98.2,110a12.22,12.22,0,0,0,8.47,4.09l.71,0a12.23,12.23,0,0,0,8.16-3.12l71.72-64Z"
    />
    <path css={{ fill: "#08a8f7" }} d="M423.66,113.21a46,46,0,1,0,0,84.69Z" />
    <path css={{ fill: "#00b4a3" }} d="M423.66,77.1l-67-35.66a7.5,7.5,0,0,0-7.05,13.24l74,39.41Z" />
  </svg>
);

export default Library;
